import { StorageKeys } from '../../helpers/localStorage';
import { ChartData, ChartMetaInfo, IExternalSaveLoadAdapter, StudyTemplateData, StudyTemplateMetaInfo } from './charting_library';

export interface WithTimestamp {
    timestamp: number
}
export interface IChartCache {
    [key: string]: ChartData & WithTimestamp;
}

export class SaveLoadAdapter implements IExternalSaveLoadAdapter {

  private getAllChartsFromStorage(): IChartCache {
    console.log('getAllChartsFromStorage');
    return JSON.parse(localStorage.getItem(StorageKeys.tv_chart) || '{}');
  }

  getAllCharts(): Promise<ChartMetaInfo[]> {
    console.log('getAllCharts');
    const chartDataCache = JSON.parse(localStorage.getItem(StorageKeys.tv_chart) ?? '[]') as IChartCache;

    const charts = Object.keys(chartDataCache).map((k: string) => {
      const c = chartDataCache[k];
      return {
        id:  Number(c.id),
        name: c.name,
        symbol: c.symbol,
        resolution: c.resolution,
        timestamp: c.timestamp
      };
    });

    return Promise.resolve(charts);
  }

  removeChart<T extends string | number>(chartId: T): Promise<void> {
    const charts = this.getAllChartsFromStorage();

    let keyToRemove = null;
    Object.keys(charts).forEach((k: string) => {
      const chartData: ChartData = charts[k];
      const currentId = Number(chartData.id);

      if (currentId === Number(chartId)) {
        keyToRemove = chartData.name;
        return;
      }
    });

    if (keyToRemove) {
      delete charts[keyToRemove];

      localStorage.setItem(StorageKeys.tv_chart, JSON.stringify(charts));
    }

    return Promise.resolve();
  }

  saveChart(chartData: ChartData): Promise<number> {
    const currentCharts = this.getAllChartsFromStorage();

    const chartDataWithTimestamp = Object.assign(chartData, {
      timestamp: new Date().getTime() / 1000,
      id: Math.random().toString(),
    });
    currentCharts[chartData.name] = chartDataWithTimestamp;

    localStorage.setItem(StorageKeys.tv_chart, JSON.stringify(currentCharts));

    return Promise.resolve(Number(chartData.id));
  }

  getChartContent(chartId: number): Promise<string> {
    const charts = this.getAllChartsFromStorage();

    let content = '';
    Object.keys(charts).forEach((k: string) => {
      const chartData: ChartData = charts[k];
      const currentId = Number(chartData.id);

      if (currentId === chartId) {
        content = chartData.content;
        return;
      }
    });

    return Promise.resolve(content);
  }

  getAllStudyTemplates(): Promise<StudyTemplateMetaInfo[]> {
    console.log('[adapter]: get all study templates');

    return Promise.resolve([]);
  }

  removeStudyTemplate(studyTemplateInfo: StudyTemplateMetaInfo): Promise<void> {
    console.log('[adapter]: remove study templates');

    return Promise.resolve();
  }

  saveStudyTemplate(studyTemplateData: StudyTemplateData): Promise<void> {
    console.log('[adapter]: save study template');

    return Promise.resolve();
  }

  getStudyTemplateContent(studyTemplateInfo: StudyTemplateMetaInfo): Promise<string> {
    console.log('[adapter]: get study template content');

    return Promise.resolve('');
  }

  getDrawingTemplates(toolName: string): Promise<string[]> {
    console.log('[adapter]: get drawing templates');

    return Promise.resolve([]);
  }

  loadDrawingTemplate(toolName: string, templateName: string): Promise<string> {
    console.log('[adapter]: loadDrawingTemplate');

    return Promise.resolve('');
  }

  removeDrawingTemplate(toolName: string, templateName: string): Promise<void> {
    console.log('[adapter]: remove drawing template');

    return Promise.resolve();
  }

  saveDrawingTemplate(toolName: string, templateName: string, content: string): Promise<void> {
    console.log('[adapter]: save drawing template');

    return Promise.resolve();
  }
}